import { Suspense } from 'react';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import ViewerLoading from '~/components/CreateNewCharacter/Canvas/ViewerLoading';
import { CanvasOptions } from '~/constants/Canvas';
import { SelectedAvatar } from './Avatar';
import Model from './Model';

interface StoreCanvasProps {
  character?: SelectedAvatar;
}

export default function StoreCanvas({ character }: StoreCanvasProps) {
  return (
    <Canvas>
      <Suspense fallback={<ViewerLoading />}>
        <PerspectiveCamera position={[0, 0, 2]} fov={60} makeDefault />

        <directionalLight
          color={CanvasOptions.lightDirectColor}
          intensity={1}
        />
        <ambientLight color={CanvasOptions.lightAmbientColor} intensity={1.2} />
        <spotLight
          color={CanvasOptions.spotLightColor}
          intensity={CanvasOptions.spotLightIntensity}
          angle={CanvasOptions.lightSpotDispersion}
        />
        <OrbitControls
          enableZoom={false}
          enablePan={false}
          minPolarAngle={Math.PI / 2}
          maxPolarAngle={Math.PI / 2}
        />
        {character && <Model character={character} />}
      </Suspense>
    </Canvas>
  );
}
